import LoginPage from '../pages/Login.vue';
import WeChatCallback from '../pages/WeChatCallback.vue';
import HomePage from '../pages/Home.vue';
import TourDiyTab from '../pages/TourDiyTab.vue';
import TourDiyList from '../pages/TourDiyList.vue';
import CashFlowPage from '../pages/CashFlow.vue';
import AddPayoutPage from '../pages/Payout/Add.vue';
import ShopPayoutPage from '../pages/Payout/List.vue';
import ProductPage from '../pages/Product/List.vue';
import ProductEditPage from '../pages/Product/Edit.vue';
import NotFoundPage from '../pages/404.vue';
import testPage from '../pages/test.vue';

var routes = [{
    path: '/',
    component: HomePage,
  }, {
    path: '/login',
    component: LoginPage,
  }, {
    path: '/test',
    component: testPage,
  },
  {
    path: '/CashFlow',
    component: CashFlowPage,
  },
  {
    path: '/ShopPayout',
    component: ShopPayoutPage,
  },
  {
    path: '/AddPayout',
    component: AddPayoutPage,
  },
  {
    path: '/WeChatCallback/:redirect',
    component: WeChatCallback,
  },
  {
    path: '/TourDiyTab/:shopId/',
    component: TourDiyTab,
    keepAlive: true,
    tabs: [{
        path: '/',
        id: 'tab1',
        component: TourDiyList,
      },
      {
        path: '/tab2/:status',
        id: 'tab2',
        component: TourDiyList,
      },
      {
        path: '/tab3/:status',
        id: 'tab3',
        component: TourDiyList,
      },
       {
        path: '/tab4/:status',
        id: 'tab4',
        component: TourDiyList,
      },
    ],
  },
  {
    path: '/Product',
    component: ProductPage,
  },
  {
    path: '/Product/Edit/:id/',
    component: ProductEditPage,
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;